export default {
    errorMsg: "",
    validationMsg: "",
    api_url: process.env.VUE_APP_API_URL,
    api_token: undefined,
    public_routes: ['connexion', 'email-verification', 'reset-password'],
};
